import { useEffect, useState } from "react";

const useCurrentTime = (refreshInterval = 30000) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = window.setInterval(() => setNow(new Date()), refreshInterval);
    return () => window.clearInterval(interval);
  }, [refreshInterval]);

  return now;
};

export default useCurrentTime;
